/**
 * TODO: Implement both web and mobile platform handling for images.
 * NOTE: Mobile handles @1x, @2x, @3x image files automatically. For web, we must require the specific image file we want to use, e.g., @3x.
 */

export default {
  helpTile1: require('shared/assets/images/help/help-tile-01@3x.png'),
  helpTile2: require('shared/assets/images/help/help-tile-02@3x.png'),
  helpTile3: require('shared/assets/images/help/help-tile-03@3x.png'),
  helpTile4: require('shared/assets/images/help/help-tile-04@3x.png'),
  helpHeader1: require('shared/assets/images/help/help-header-01@3x.png'),
  helpHeader2: require('shared/assets/images/help/help-header-02@3x.png'),
  helpHeader3: require('shared/assets/images/help/help-header-03@3x.png'),
  helpHeader4: require('shared/assets/images/help/help-header-04@3x.png'),
  success: require('shared/assets/images/success@3x.png'),
  success2: require('shared/assets/images/success2@3x.png'),
  return: require('shared/assets/images/return@3x.png'),
  exclamation: require('shared/assets/images/exclamation@3x.png'),
};
